'use strict';

module Patersons {
    export class CashHoldingsReport {
        holdings: CashHolding[];
        total: CashHolding;
    }

    export class CashHolding {
        instituteCode: string;
        accountName: string;
        balance: number;
        type: string;
	interestRate: number;
        hasData(): boolean {
            return ((typeof this.instituteCode != 'undefined' && this.instituteCode) ||
                (typeof this.accountName != 'undefined' && this.accountName) ||
                (typeof this.type != 'undefined' && this.type) ||
                (typeof this.balance != 'undefined' && this.balance)) as any;
        }
    }

    export class CashHoldingsReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/cashHoldingsReport.component.html';
        bindings: any = {
            title: '@',
            report: '<',
            predicate: '<',
            sortOrder: '<',
            searchText: '<',
            onOrderChanged: '&'
        };
    }
}